import { render, staticRenderFns } from "./MealDetailTable2.vue?vue&type=template&id=5a17db4c&"
import script from "./MealDetailTable2.vue?vue&type=script&lang=js&"
export * from "./MealDetailTable2.vue?vue&type=script&lang=js&"
import style0 from "./MealDetailTable2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports